/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

import { ModuleWithProviders, NgModule } from "@angular/core";
// import { WebcamModule } from 'ngx-webcam';
// import { NgxDropzoneModule } from "ngx-dropzone";

import { SharedModule } from "./shared.module";
import { MaterialModules } from "./material.module";
import { BootstrapModules } from "./bootstrap.module";

// Admin :: Shared Components
import {
  AdminAssociateAddDialogComponent,
  AdminSalesforceAddAxaSchemeDialogComponent,
  AdminSalesforceAddBandingLfaDialogComponent,
  AdminSalesforceAddBandingGiDialogComponent,
  AdminSalesforceAddMovementDialogComponent,
  AdminSalesforceAddProviderCodeDialogComponent,
  AdminSalesforceOffboardDialogComponent,
  AdminSubmissionMediaDialogComponent,
  AdminPayrollBatchAddDialogComponent,
  AdminBscBatchAddDialogComponent,
  AdminProductsAddSeriesDialogComponent,
  AdminProductsAddOptionsDialogComponent,
  AdminProductsEditOptionsDialogComponent,
  AdminProductOptionsTagRidersDialogComponent,
  AdminBscTagSubmissionDialogComponent,
  AdminProductsAddRidersDialogComponent,
} from "@app/@shared/components/admin";

// Admin :: Shared Services
import { AdminAssociateResolverService, AdminSalesAssociatesService } from "@app/@shared/services/admin/sales-associates";
import { AdminClientResolverService, AdminClientRelationshipsService } from "@app/@shared/services/admin/client-relationships";
import { AdminClientPoliciesResolverService, AdminClientPoliciesService } from "@app/@shared/services/admin/client-policies";
import { AdminCaseSubmissionsResolverService, AdminCaseSubmissionsService } from "@app/@shared/services/admin/case-submissions";
import { AdminPayrollBatchResolverService, AdminPayrollService } from "@app/@shared/services/admin/payroll";
import { AdminBscBatchResolverService, AdminComplianceService } from "@app/@shared/services/admin/compliance";
import { AdminProductsCatalogService } from "@app/@shared/services/admin/products-catalog";
import { AdminSettingsService } from "@app/@shared/services/admin/settings";
import { AdminUserAccountsService, AdminUserResolverService } from "@app/@shared/services/admin/user-accounts";

export const AdminProviders = [
  AdminSalesAssociatesService,
  AdminAssociateResolverService,
  AdminUserResolverService,
  AdminClientResolverService,
  AdminClientRelationshipsService,
  AdminClientPoliciesResolverService,
  AdminClientPoliciesService,
  AdminCaseSubmissionsResolverService,
  AdminCaseSubmissionsService,
  AdminPayrollBatchResolverService,
  AdminPayrollService,
  AdminBscBatchResolverService,
  AdminComplianceService,
  AdminProductsCatalogService,
  AdminSettingsService,
  AdminUserAccountsService,
];

@NgModule({
  imports: [
    SharedModule,
    BootstrapModules,
    MaterialModules,
    // WebcamModule,
    // NgxDropzoneModule,
  ],
  declarations: [
    AdminAssociateAddDialogComponent,
    AdminSalesforceAddAxaSchemeDialogComponent,
    AdminSalesforceAddBandingLfaDialogComponent,
    AdminSalesforceAddBandingGiDialogComponent,
    AdminSalesforceAddMovementDialogComponent,
    AdminSalesforceAddProviderCodeDialogComponent,
    AdminSalesforceOffboardDialogComponent,
    AdminSubmissionMediaDialogComponent,
    AdminPayrollBatchAddDialogComponent,
    AdminBscBatchAddDialogComponent,
    AdminProductsAddSeriesDialogComponent,
    AdminProductsAddRidersDialogComponent,
    AdminProductsAddOptionsDialogComponent,
    AdminProductsEditOptionsDialogComponent,
    AdminProductOptionsTagRidersDialogComponent,
    AdminBscTagSubmissionDialogComponent,
  ],
  exports: [
    SharedModule,
    BootstrapModules,
    MaterialModules,
    AdminAssociateAddDialogComponent,
    AdminSalesforceAddAxaSchemeDialogComponent,
    AdminSalesforceAddBandingLfaDialogComponent,
    AdminSalesforceAddBandingGiDialogComponent,
    AdminSalesforceAddMovementDialogComponent,
    AdminSalesforceAddProviderCodeDialogComponent,
    AdminSalesforceOffboardDialogComponent,
    AdminSubmissionMediaDialogComponent,
    AdminPayrollBatchAddDialogComponent,
    AdminBscBatchAddDialogComponent,
    AdminProductsAddSeriesDialogComponent,
    AdminProductsAddRidersDialogComponent,
    AdminProductsAddOptionsDialogComponent,
    AdminProductsEditOptionsDialogComponent,
    AdminProductOptionsTagRidersDialogComponent,
    AdminBscTagSubmissionDialogComponent,
  ],
  entryComponents: [
    AdminAssociateAddDialogComponent,
    AdminSalesforceAddAxaSchemeDialogComponent,
    AdminSalesforceAddBandingLfaDialogComponent,
    AdminSalesforceAddBandingGiDialogComponent,
    AdminSalesforceAddMovementDialogComponent,
    AdminSalesforceAddProviderCodeDialogComponent,
    AdminSalesforceOffboardDialogComponent,
    AdminSubmissionMediaDialogComponent,
    AdminPayrollBatchAddDialogComponent,
    AdminBscBatchAddDialogComponent,
    AdminProductsAddSeriesDialogComponent,
    AdminProductsAddRidersDialogComponent,
    AdminProductsAddOptionsDialogComponent,
    AdminProductsEditOptionsDialogComponent,
    AdminProductOptionsTagRidersDialogComponent,
    AdminBscTagSubmissionDialogComponent,
  ],
})
export class AdminServicesModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: AdminServicesModule,
      providers: [...AdminProviders],
    };
  }
}
